import actions from '../../actionTypes';

export default site => {
  return {
    type: actions.EDITED_SITE_LABELS,
    site
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/editedSiteLabels.js